import React, { useReducer, createContext } from "react";

const initialState = {
  inMemRoute: "/",
};

let lastRoute = process.env.REACT_APP_LAST_ROUTE || "lastRoute";

if (localStorage.getItem(lastRoute)) {
  initialState.inMemRoute = localStorage.getItem(lastRoute) || "";
}

const RouteContext = createContext({
  inMemRoute: "",
  setRoute: (lastRoute) => {},
  resetRoute: () => {},
});

const routeReducer = (state, action) => {
  switch (action.type) {
    case "SET": {
      return {
        ...state,
        inMemRoute: action.payload,
      };
    }
    case "RESET": {
      return {
        ...state,
        inMemRoute: "/",
      };
    }
    default:
      return state;
  }
};

function RouteProvider(props) {
  const [state, dispatch] = useReducer(routeReducer, initialState);

  const setRoute = (lastRouteParam) => {
    localStorage.setItem(lastRoute, lastRouteParam);
    dispatch({
      type: "SET",
      payload: lastRouteParam,
    });
  };

  const resetRoute = () => {
    localStorage.removeItem(lastRoute);
    dispatch({
      type: "RESET",
      payload: "",
    });
  };

  return (
    <RouteContext.Provider
      value={{
        inMemRoute: state.inMemRoute,
        setRoute,
        resetRoute,
      }}
      {...props}
    />
  );
}

export { RouteContext, RouteProvider };
